import React, { useEffect, useState } from 'react';
import { BrowserMultiFormatReader, NotFoundException } from '@zxing/library';
import { toastSuccess } from '../../common/Toast';

function ScannerTest() {
  const [selectedDeviceId, setSelectedDeviceId] = useState(null);
  const [videoInputDevices, setVideoInputDevices] = useState([]);
  const [result, setResult] = useState('');
  const [codeReader] = useState(new BrowserMultiFormatReader()); // Keep the same instance of the reader

  useEffect(() => {
    // Fetch video input devices on component mount
    navigator.mediaDevices
      .enumerateDevices()
      .then((devices) => {
        const videoDevices = devices.filter((device) => device.kind === 'videoinput');
        setVideoInputDevices(videoDevices);

        // Automatically select the back camera if available
        const defaultDevice = videoDevices.find((device) =>
          device.label.toLowerCase().includes('back')
        ) || videoDevices[0];

        if (defaultDevice) {
          setSelectedDeviceId(defaultDevice.deviceId);
        }
      })
      .catch((err) => console.error('Error enumerating devices:', err));

    return () => {
      codeReader.reset(); // Cleanup on unmount
    };
  }, [codeReader]);

  const startDecode = () => {
    if (selectedDeviceId) {
      const constraints = {
        video: {
          deviceId: { exact: selectedDeviceId }, // Use selected device
          facingMode: 'environment', // Prefer back camera
        },
      };

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          const videoElement = document.getElementById('video');
          if (videoElement) {
            videoElement.srcObject = stream;
            videoElement.play();
          }

          codeReader.decodeFromVideoDevice(selectedDeviceId, 'video', (result, err) => {
            if (result) {
              toastSuccess(result?.text);
              setResult(result.text);
            } else if (err && !(err instanceof NotFoundException)) {
              console.error(err);
            }
          });
        })
        .catch((err) => console.error('Error accessing camera:', err));
    }
  };

  const resetDecode = () => {
    codeReader.reset();
    setResult('');
    const videoElement = document.getElementById('video');
    if (videoElement) {
      const stream = videoElement.srcObject;
      if (stream) {
        const tracks = stream.getTracks();
        tracks.forEach((track) => track.stop());
      }
      videoElement.srcObject = null;
    }
  };

  return (
    <main className="wrapper" style={{ paddingTop: '2em' }}>
      <section className="container">
        <div style={{ border: '1px solid gray' }}>
          <video
            id="video"
            style={{
              width: '-webkit-fill-available',
            }}
          ></video>
        </div>
        <div>
          <button onClick={startDecode}>Start</button>
          <button onClick={resetDecode}>Reset</button>
        </div>

        {videoInputDevices.length > 1 && (
          <div>
            <label htmlFor="sourceSelect">Change video source:</label>
            <select
              id="sourceSelect"
              value={selectedDeviceId || ''}
              onChange={(e) => {
                setSelectedDeviceId(e.target.value);
                resetDecode(); // Reset the scanner before switching
              }}
            >
              {videoInputDevices.map((device, index) => (
                <option key={index} value={device.deviceId}>
                  {device.label || `Device ${index + 1}`}
                </option>
              ))}
            </select>
          </div>
        )}

        <label>Result:</label>
        <pre>
          <code>{result}</code>
        </pre>
      </section>
    </main>
  );
}

export default ScannerTest;
